import React from 'react'
import SpecialMatchList from '../components/match-list/containers/special-match-list/special-match-list';
import { DisciplineLiveStatus } from '@om-fe/models';
import { MatchListItemLayout } from '../components/match-list/utils/match-list.constants';
import { BonusType, MatchListSpecialHeader } from '../components/match-list-group/match-list-special-header';
import getConfig, { OMFE2ConfigModel } from '@om-fe/core/utils/config';

const specialMatchListInstanceId: string = 'special-bet-match-list';
const config: OMFE2ConfigModel = getConfig();
const specialBonusSingle: boolean = config?.specialBonus?.single;
const specialBonusMulti: boolean = config?.specialBonus?.multi;

export const SpecialBonusPage = () => {
  return (
    <>
        {specialBonusSingle && (
            <>
                <MatchListSpecialHeader bonusType={BonusType.Single} /> 
                <SpecialMatchList 
                    showMatchListHeader={false}
                    showMarketInMatchListGroupHeader={true}
                    mainMarketsLimit={3}
                    instanceId={`${specialMatchListInstanceId}-single`}
                    limitNumberOfEvents={10}
                    liveStatus={DisciplineLiveStatus.BOTH}
                    itemLayout={MatchListItemLayout.Special}
                    bonusType={BonusType.Single}
                />
            </>
        )}
        {specialBonusMulti && (
            <>
                <MatchListSpecialHeader bonusType={BonusType.Multi} /> 
                <SpecialMatchList 
                    showMatchListHeader={false}
                    showMarketInMatchListGroupHeader={true}
                    mainMarketsLimit={3}
                    instanceId={`${specialMatchListInstanceId}-multi`}
                    limitNumberOfEvents={10}
                    liveStatus={DisciplineLiveStatus.BOTH}
                    itemLayout={MatchListItemLayout.Special}
                    bonusType={BonusType.Multi}
                />
            </>
        )}
    </>
  )
}
